export const defaultAuthCopyByI18nKey: Record<string, string> = {
  'auth:branding.subtitle': 'Hire once, work forever.',
  'auth:signInTitle': 'Welcome Back',
  'auth:signInSubtitle': 'Sign in to continue to your workspace.',
  'auth:signInMagicLinkSubtitle': "Enter your email and we'll send you a secure sign-in link.",
  'auth:magicLinkSentTitle': 'Check your email',
  'auth:magicLinkSentSubtitle': 'We sent you a secure sign-in link.',
  'auth:checkYourEmailForLogin': 'Open the magic link in your email to continue.',
  'auth:checkYourEmail': 'Use the link in your email to continue.',
  'auth:checkYourEmailForReset': 'Open the reset link in your email to continue.',
  'auth:noAccount': "Don't have an account?",
  'auth:alreadyAccount': 'Already have an account?',
  'auth:useMagicLink': 'Use magic link',
  'auth:usePassword': 'Use password',
  'auth:continue': 'Continue',
  'auth:forgotPassword': 'Forgot password?',
  'auth:backToLoginLink': 'Back to Sign In',
  'auth:signUp': 'Sign Up',
  'auth:signIn': 'Sign In',
  'auth:signInLink': 'Sign In',
  'auth:signUpLink': 'Sign Up',
  'auth:signUpButton': 'Create account',
  'auth:continueWithGoogle': 'Continue with Google',
  'auth:resendMagicLinkButton': 'Resend link',
  'auth:sendMagicLinkButton': 'Send magic link',
  'auth:sendResetLinkButton': 'Send reset link',
  'auth:forgotPasswordTitle': 'Reset your password',
  'auth:forgotPasswordSubtitle': "Enter your email and we'll send you a reset link.",
  'auth:resetLinkSentTitle': 'Check your email',
  'auth:resetLinkSentSubtitle': 'We sent a password reset link.',
  'auth:signUpTitle': 'Create your account',
  'auth:signUpSubtitle': 'Start building with your Dopomogai workspace.',
  'auth:signUpSuccessTitle': 'Check your email',
  'auth:signUpSuccessSubtitle': 'We sent a confirmation link to finish creating your account.',
  'auth:emailPlaceholder': 'Enter your email',
  'auth:passwordPlaceholder': 'Enter your password',
  'auth:confirmPassword': 'Confirm password',
  'auth:confirmPasswordPlaceholder': 'Re-enter your password',
  'auth:newPasswordLabel': 'New password',
  'auth:newPasswordPlaceholder': 'Enter your new password',
  'auth:updatePasswordTitle': 'Update your password',
  'auth:updatePasswordSubtitle': 'Set a new password for your account.',
  'auth:updatePasswordExpiredSubtitle': 'Your reset link is invalid or expired. Please request a new one.',
  'auth:updatePasswordButton': 'Update password',
  'auth:passwordUpdatedTitle': 'Password updated',
  'auth:passwordUpdatedSubtitle': 'Your password has been updated. You can now continue.',
  'auth:errors.pleaseSignIn': 'Please sign in.',
  'common:email': 'Email',
  'common:password': 'Password',
  'common:or': 'OR',
};
